<template>
    <np-modal id="company-search-modal" :title="lang('company_search')" :class="''" :modal-dialog-class="'modal-dialog-scrollable modal-dialog--company-search'" mode="custom" :loading="loading">
        <div class="row my-3">
            <div class="col-12">
                <div class="row mb-3">
                    <div class="col-12">
                        <np-radios
                                ref="company_search_option"
                                :label="lang('company_search_option')"
                                :id="'company_search_option'"
                                :name="'company_search_option'"
                                mode="co-join"
                                :options="searchByRadiosConfig"
                                @input="toggleCompanySearchOption"
                                v-model="searchBy">
                        </np-radios>
                        <np-input
                                  v-bind="$attrs"
                                  @enter="search"
                                  @addon-click="search"
                                  :no-wrapper="false"
                                  v-model="searchValue"
                                  ref="input"
                                  :required="false"
                                  @input="val => $emit('input', val)">
                            <template #addon>
                                <i v-if="searching" class="fa fa-spinner fa-spin"></i>
                                <i v-else class="fa fa-search"></i>
                            </template>
                        </np-input>
                    </div>
<!--                    show select company if its company search and if company list has been added.-->
                    <div class="col-12" v-if="objectIsNotEmpty(filteredCompanyList) && show_reg_number_options">
                        <np-select2
                                :hide-label="true"
                                @close="selected"
                                :parameters="filteredCompanyList"
                                :placeholder="lang('company')"
                                :aria-label="lang('select_company')"
                                ref="select2"
                                :required="false"
                                z-index="9000"
                                :open="companySelect2Open"
                                @update:modelValue="selectCompany($event)">
                        </np-select2>
                    </div>
<!--                    <div class="col-lg-6 col-md-6 col-12">-->
<!--                        <div class="form-group input-group mb-3">-->
<!--                            <input v-if="searchBy === searchByOptions.company_name" placeholder="Company Name" type="text" class="form-control ignoreValidation" aria-label="company Name" v-model="dataCompanyName"/>-->
<!--                            <input v-else placeholder="Register Number"  type="text" class="form-control ignoreValidation" aria-label="Registration Number" v-model="dataRegNumber"/>-->

<!--                            <div class="input-group-append">-->
<!--                                <button type="button" class="btn btn-success search-addon" @click="search" :aria-label="lang('search')"><i class="fa fa-search"> </i></button>-->
<!--                            </div>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                    <div class="col-lg-6 col-md-6 col-12">-->
<!--                        <np-radios id="company-search-by"-->
<!--                                   :mode="'co-join'"-->
<!--                                   :no-wrapper="true"-->
<!--                                   :hide-label="true"-->
<!--                                   :options="searchByRadiosConfig"-->
<!--                                   v-model="searchBy">-->
<!--                        </np-radios>-->
<!--                    </div>-->
                </div>
                <div class="row" v-if="!loading">
<!--                    <div class="col-lg-3 col-md-4 col-12 mb-3" v-if="searchBy === searchByOptions.company_name">-->
<!--                        <div class="clearfix companyMenuList" style="min-height: fit-content; max-height: fit-content;">-->
<!--                            <div class="form-group input-group">-->
<!--                                <div class="input-group-prepend">-->
<!--                                    <div class="input-group-text">-->
<!--                                        <i class="fa fa-filter"></i>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <input class="dd_filter ignoreValidation form-control" placeholder="Filter Results"-->
<!--                                       v-model="companyFilterKey"/>-->
<!--                            </div>-->
<!--                            <div class="dd_companyList list-group">-->
<!--                                <a v-for="company in filteredCompanyList"-->
<!--                                   class="dd_companyCell list-group-item list-group-item-action"-->
<!--                                   :class="{dd_activeCompany: selectedCompany && selectedCompany === company}"-->
<!--                                   @click="selectCompany(company)">-->
<!--                            <span v-for="(c, index) in company.name" class="company-name-char"-->
<!--                                  :class="{match: isCharMatchKey(company.name, index)}">{{c}}</span>-->
<!--                                    <span>{{company.reg_no}}</span>-->
<!--                                </a>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                        <div class="companyMenuSelect">-->
<!--                            <np-select2-->
<!--                                    ref="country_code"-->
<!--                                    :id="`country_code`"-->
<!--                                    :name="`country_code`"-->
<!--                                    :label="lang('country')"-->
<!--                                    :placeholder="lang('country')"-->
<!--                                    :mode="`country`"-->
<!--                                    @input=""-->
<!--                                    :parameters="filteredCompanyList.map(obj => {return obj.text = })"-->
<!--                                    :no-wrapper="false"-->
<!--                                    v-model="merchant.registration_address.country_code">-->
<!--                            </np-select2>-->
<!--                        </div>-->

<!--                    </div>-->
<!--                    <div :class="{'col-12': searchBy === searchByOptions.reg_no, 'col-lg-9 col-md-8 col-12 ps-0': searchBy === searchByOptions.company_name}">-->
                    <div class="col-12" v-if="objectIsNotEmpty(companyDetail) || objectIsNotEmpty(personnel_data)">
                            <np-skeleton v-if="!companyAddresses && !companyDetail && !personnel_data" :type="'panel_only'">
                            </np-skeleton>

                        <div class="card" v-if="companyDetail && personnel === 0">
                            <div class="card-header">{{lang('select_business_details')}}</div>
                            <div class="card-body">
                                    <div class="col-12">
                                        <div class="row dd_borders business-detail" v-for="detail in companyDetail">
                                            <div class="dd_shareholder col-lg-5 col-md-6 col-12">
                                                <label class="fontSize12 bold">{{lang(detail.key)}}</label>
<!--                                               doubt this is necessary-->
                                                <np-checkbox class="displayNone" v-if="!isDescriptive(detail.key)"
                                                             v-show="false" no-wrapper :id="`select-${detail.key}`"
                                                             :description="lang(detail.key)"
                                                             v-model="detail.selected"></np-checkbox>
                                            </div>
                                            <div class="dd_shareholder col-lg-7 col-md-6 col-12">
                                                <label class="fontSize12">{{!!detail.value ? detail.value : '-'}}</label>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>
<!--                        address-->
                        <div class="card" v-if="companyAddresses && personnel === 0">
                            <div class="card-header">{{lang('select_address')}}</div>
                            <div class="card-body">
                                <div class="fontSize12">
                                    <np-select2 v-if="addressOptions.length > 5"
                                        :hide-label="true"
                                        :id="'selectedAddressIndex'"
                                        :name="'selectedAddressIndex'"
                                        :aria-label="lang('address')"
                                        :placeholder="lang('address')"
                                        :required="false"
                                        :parameters="addressOptions"
                                        :no-wrapper="false"
                                        :open="select2Open"
                                        v-model="selectedAddressIndex">
                                    </np-select2>
                                        <np-radios v-else
                                                :label="lang('address')"
                                                :id="'selectedAddressIndex'"
                                                :name="'selectedAddressIndex'"
                                                :no-wrapper="true"
                                                :as-block="true"
                                                class="dd_borders"
                                                :hide-label="true"
                                                :options="addressOptions"
                                                v-model="selectedAddressIndex">
                                        </np-radios>
                                </div>
                            </div>
                        </div>
                        <!-- shareholders -->
                        <div class="card" v-if="personnel_data && personnel > 0">
                            <div class="card-header">{{lang('duedil_shareholders_list')}}</div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12" v-if="hasShareholders">
                                        <div class="row" v-if="shareholderOptions.length > 0">
                                            <div class="col-12">
                                                <div class="panel-sub-heading headingSmall pt-0"><span
                                                        class="markedBottom fontSize14">{{lang('duedil_personnel')}}</span>
                                                </div>
                                                <np-radios
                                                        :label="lang('address')"
                                                        :id="'selectedPersonnelIndex'"
                                                        :name="'selectedPersonnelIndex'"
                                                        :no-wrapper="true"
                                                        :as-block="true"
                                                        :hide-label="true"
                                                        :auto-select="false"
                                                        :options="shareholderOptions"
                                                        @update:modelValue="toggleDirectors"
                                                        v-model="selectedShareholderIndex">
                                                </np-radios>
                                            </div>
                                        </div>
                                        <div class="row" v-if="companiesInShareholderList.length > 0">
                                            <div class="col-12">
                                                <div class="panel-sub-heading headingSmall pt-0"><span
                                                        class="markedBottom fontSize14">{{lang('duedil_company')}}</span>
                                                </div>
                                                <div class="dd_shareholder_company">
                                                    <a class="dd_search_for_c addTooltip"
                                                       href="#"
                                                       v-for="(company) in companiesInShareholderList"
                                                       @click="searchPersonnelCompany(company['legal_name'])"
                                                       data-original-title="" title=""><i
                                                            class="fa fa-search me-1"></i>
                                                        <b>{{company.label}}</b></a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" v-else>
                                        <label>{{lang('duedil_no_shareholders_information_found')}}</label>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- directors -->
                        <div class="card" v-if="personnel_data && personnel > 0">
                            <div class="card-header">{{lang('duedil_directors_list')}}</div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12" v-if="hasDirectors">
                                        <div class="row" v-if="directorOptions.length > 0">
                                            <div class="col-12">
                                                <div class="panel-sub-heading headingSmall pt-0"><span
                                                        class="markedBottom fontSize14">{{lang('duedil_personnel')}}</span>
                                                </div>
                                                <np-radios
                                                        :label="lang('address')"
                                                        :id="'selectedDirectorIndex'"
                                                        :name="'selectedDirectorIndex'"
                                                        :no-wrapper="true"
                                                        :as-block="true"
                                                        :hide-label="true"
                                                        :auto-select="false"
                                                        :options="directorOptions"
                                                        @update:modelValue="toggleShareholders"
                                                        v-model="selectedDirectorIndex">
                                                </np-radios>
                                            </div>
                                        </div>
                                        <div class="row" v-if="companiesInDirectorList.length > 0">
                                            <div class="col-12">
                                                <div class="panel-sub-heading headingSmall pt-0"><span
                                                        class="markedBottom fontSize14">{{lang('duedil_company')}}</span></div>
                                                <div class="dd_shareholder_company">
                                                    <a class="dd_search_for_c addTooltip"
                                                       href="#"
                                                       v-for="(company) in companiesInDirectorList"
                                                       @click="selectCompany(company)"
                                                       data-original-title="" title=""><i class="fa fa-search me-1"></i>
                                                        <b>{{company.label}}</b></a></div>
                                            </div>
                                        </div>
<!--                                        Found an interesting case with ASDA so I added this block-->
                                        <div class="row" v-if="!directorOptions.length > 0 && !companiesInDirectorList.length > 0">
                                            <div class="col-12">
                                                <label>{{lang('duedil_no_directors_information_found')}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12" v-else>
                                        <label>{{lang('duedil_no_directors_information_found')}}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
<!--                    <div class="col-12" v-else>-->
<!--                        <np-notice :notice="error_message" :notice-class="'alert-warning'"></np-notice>-->
<!--                    </div>-->
                </div>
                <div class="row" v-else>
                    <div class="col-12">
                        <np-skeleton :type="'panel_only'">
                        </np-skeleton>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
        <div class="modal-footer">
            <a class="btn btn-danger" data-bs-dismiss="modal">{{lang('cancel')}}</a>
            <a class="btn btn-default" data-bs-dismiss="modal" @click="useSelectedDetails">{{lang('use_selected_details')}}</a>
        </div>
        </template>
    </np-modal>
</template>

<script>
    import Fuse from 'fuse.js';
    import NPModal from './np-modal.vue';
    import NPRadio from './np-radios.vue';
    import NPCheckbox from './np-checkbox.vue';
    import NPSkeleton from "./np-skeleton.vue";
    import NPInput from './np-input.vue';
    import NPSelect2 from "./np-select2.vue";
    import NPNotice from "./np-notice.vue";
    import {defaultCountry} from "../../entities/default";
    //import EventBus from '../../utils/event_bus';

    export default {
        name: 'np-company-search',
        components: {
            'np-modal': NPModal,
            'np-radios': NPRadio,
            'np-checkbox': NPCheckbox,
            'np-skeleton': NPSkeleton,
            'np-input': NPInput,
            'np-select2': NPSelect2,
            'np-notice': NPNotice,
        },
        props: {
            country: String,
            country_code: String,
            companyName: String,
            refType: String,
            reference: {},
            personnel: {
                type: Number,
                default: 0
            },
            registrationNumber: String,
            vatNumber: String,
            businessType: String,
            search_transparent_data: false,
            search_bisnode_data: false,
            companyAdaptor: {
                type: Function,
                default: function (companies) {
                    let company_list = [];
                    if (Array.isArray(companies)) {
                        companies.forEach(company => {
                            if (company && company.id) {
                                let company_item = {
                                    name: company.name,
                                    id: company.id,
                                    reg_no: company.registration_number
                                };
                                company_list.push(company_item);
                            }
                        });
                    }
                    return company_list;
                }
            },
            companyDetailAdaptor: {
                type: Function,
                default: function (d) {
                    const mapping = {
                        legal_name: 'legal_name',
                        date_incorporation: 'incorporation_date',
                        reg_no: 'registration_number',
                        vat_no: 'vat_number',
                        // accounts_turnover: 'accounts_turnover',
                        business_type: 'type',
                        reg_web: 'reg_web',
                        // description: 'description',
                        trading_address: 'trading_address',
                        // website:'website',
                    };

                    //website may have replaced reg_web in bisnode // No longer needed
                    // if (!!d && !!d['website']){
                    //     mapping['reg_web'] = 'website';
                    // }

                    const data = [];
                    for (let key in mapping) {

                        if (!mapping.hasOwnProperty(key) || (!d || !d.hasOwnProperty(mapping[key]))) { //check that d !== undefined
                            continue;
                        }

                        let value = d[mapping[key]];
                        if (key === 'trading_address'){
                            value = !!value && !!value.summary ? value.summary : (!!value ? value : '')
                        }

                        //formatDate to be dd-mm-yyyy because transparentdata returns yyyy-mm-dd
                        if (key === 'date_incorporation' && !!value && value !== '') {
                            let date_value = value.split('-');
                            if (date_value[0].length === 4) {
                                //this means that value is yyyy-mm-dd and we need to format it to dd-mm-yyyy
                                value = !!value ? this.formatDate(value) : value;
                            }
                        }

                        data.push({
                            key: key,
                            value: value,
                            selected: '1',
                        });
                    }
                    return data;
                }
            },
            shareholderAdaptor: {
                type: Function,
                default: function(data) {
                    const d = data;
                    return {
                        first_name: d.first_name,
                        last_name: d.last_name,
                        name: d.name,
                        title: d.title,
                        date_of_birth: d.date_of_birth,
                    }
                }
            },
            addressAdaptor: {
                type: Function,
                default: function(data) {
                    return {
                        addressLine1: this.removeNumberFromString(data.address_line1),
                        addressLine2: data.addressLine2,
                        building_name: data.buildingName,
                        building_number: this.getNumberFromString(data.address_line1),
                        city: data.city,
                        county: data.county,
                        flatName: data.flatName,
                        locality: data.locality,
                        postcode: data.postcode,
                        street: this.removeNumberFromString(data.address_line1),
                        country_code: this.country_code,
                        summary: data.summary || data.address_line1,
                    }
                }
            },
            show_reg_num_options: {
                type: Boolean,
                default: false
            }
        },
        data: function () {
            const searchByOptions = {
                company_name: 'company_name',
                reg_no: 'reg_no',
                vat_no: 'vat_no'
            };
            return {
                searchByOptions: searchByOptions,
                searchBy: searchByOptions.reg_no,
                companyList: [],
                cache: {
                    director: {},
                    shareholder: {},
                    company: {},
                    company_search: {},
                },
                selectedCompany: null,
                companyFilterKey: '',
                companyDetail: null,
                registered_address: null,
                companyAddresses: null,
                selectedAddressIndex: null,
                selectedShareholderIndex: null,
                selectedDirectorIndex: null,
                shareholders: [],
                personnel_data: {},
                dataCompanyName: this.companyName,
                dataRegNumber: this.registrationNumber,
                dataVatNumber: this.vatNumber,
                loading: false,
                cacheKeys: ['company', 'director', 'shareholder'],
                isMobileView: window.innerWidth < 576,
                windowWidth: 0,
                selectMode: false,
                searching: false,
                searchValue: '',
                select2Open: false,
                companySelect2Open: false,
                error_message: this.lang('details_not_found'),
                previous_search: null,
            }
        },
        created() {
            // this.resizeModal();
            // window.addEventListener("resize", this.resizeModal);
        },
        destroyed() {
            // window.removeEventListener("resize", this.resizeModal);
        },
        computed: {
            show_reg_number_options: function () {
                return this.searchBy !== this.searchByOptions.reg_no || this.show_reg_num_options
            },
            regNumberLabel: function(){
                let vm = this
                if(this.allianceCountry == '616'){
                    return this.lang('krs_reg_number')
                }
                return this.lang(vm.searchByOptions.reg_no);
            },
            searchByRadiosConfig() {
                let vm = this;
                let company_name_option = {value: vm.searchByOptions.company_name, label: vm.lang(vm.searchByOptions.company_name)};
                let reg_no_option = {value: vm.searchByOptions.reg_no, label: vm.lang(vm.searchByOptions.reg_no)};
                let vat_option = {value: vm.searchByOptions.vat_no, label: vm.lang(vm.searchByOptions.vat_no)};
                switch (this.countryCode) {
                    case 'GBR':
                    case 'IRL':
                    case 'DEU':
                        return [company_name_option, reg_no_option];

                    case 'POL':
                        return [vat_option];

                    case 'SWE':
                        return [reg_no_option];

                    case 'NOR':
                        return [reg_no_option];

                    default:
                        return [company_name_option];
                }
            },
            filteredCompanyList() {
                return this.filterCompany(this.companyFilterKey).map(obj => {
                    // obj.text = obj.name + ' <br>' + obj.reg_no;
                    obj.text = obj.name;
                    // obj.id = obj.name;

                    return obj;
                });
            },
            selectedCompanyDetails() {
                return this.companyDetail ? this.companyDetail.filter(e => e.selected === '1') : [];
            },
            addressOptions() {
                if(!!this.companyAddresses) {
                    return this.companyAddresses.map((obj, index) =>  {
                        return {
                            value: index,
                            id: index,
                            label: obj.summary,
                            text: obj.summary,
                        }
                    });
                }
            },
            hasShareholders() {
                return (!!this.personnel_data.shareholders && this.personnel_data.shareholders.length > 0);
            },
            hasDirectors() {
                return !!this.personnel_data.directors && this.personnel_data.directors.length > 0 && this.objectIsNotEmpty(this.personnel_data.directors[0].details)
            },
            directorOptions() {
                let personnel = [], vm = this;
                if(vm.hasDirectors) {
                    personnel = this.personnel_data.directors.reduce((acc, obj) => { return (obj.type === 'person' || vm.polishTypeCheck(obj) ) ?  acc.concat(Object.assign(obj, {value: vm.getFullName(obj.details), label: vm.prepValue(obj, false)})) : acc; } , [])
                }
                return personnel;
            },
            shareholderOptions() {
                let personnel = [], vm = this;
                if(vm.hasShareholders) {
                    personnel = this.personnel_data.shareholders.reduce((acc, obj) => { return (obj.type === 'person' || vm.polishTypeCheck(obj) ) ?  acc.concat(Object.assign(obj, {value: vm.getFullName(obj.details), label: vm.prepValue(obj, true)})) : acc; } , [])
                }
                return personnel;
            },
            companiesInDirectorList() {
                let personnel = [], vm = this;
                if(vm.hasDirectors) {
                    personnel = this.personnel_data.directors.reduce((acc, obj) => { return (obj.type === 'company') ? acc.concat(Object.assign(obj,{legal_name: obj.details.legal_name, label: vm.prepValue(obj, false)})) : acc; } , [])
                }
                return personnel;
            },
            companiesInShareholderList() {
                let personnel = [], vm = this;
                if(vm.hasShareholders) {
                    personnel = this.personnel_data.shareholders.reduce((acc, obj) => { return (obj.type === 'company') ? acc.concat(Object.assign(obj,{legal_name: obj.details.legal_name, label: vm.prepValue(obj, true)})) : acc; } , [])
                }
                return personnel;
            },
            countryCode() {
                return !!this.country  ? this.country : 'GBR';
            },
            allianceCountry: function() {
                return defaultCountry;
            },
        },
        mounted: function () {
            //searchBy check
            this.searchBy = !!this.dataCompanyName ? this.searchByOptions.company_name : this.searchBy;
            this.searchBy = !!this.dataRegNumber ? this.searchByOptions.reg_no : this.searchBy;
            this.searchBy = this.countryCode === 'POL' && this.personnel > 0 ? this.searchByOptions.vat_no : this.searchBy;

            const searchByCompany = this.searchBy === this.searchByOptions.company_name && !!this.dataCompanyName;
            const searchByRegNo = this.searchBy === this.searchByOptions.reg_no && !!this.dataRegNumber;
            const searchOnStart = searchByCompany || searchByRegNo;
            if (searchOnStart) {
                this.search();
            }
        },
        methods: {
            polishTypeCheck: function(obj) {
                //creditsafe (search by name/reg_no) may return type as "other"
                //transparent data (search vat) will return type as "" for now. We will ask tgateway to change that and send the "pesel" key

                if(this.countryCode === 'POL' && obj.type === 'other' && obj.details && obj.details.hasOwnProperty('legal_name'))
                {
                    let names = obj.details.legal_name.split(' ')
                    if(!obj.details.first_name && !!names[0] && names.length > 1) {
                        obj.details.first_name = names[0]
                    }
                    if(!obj.details.first_second && !!names[1] && names.length > 2){
                        obj.details.first_second = names[1]
                    }
                    if(!obj.details.last_name && !!names[2] && names.length > 2 ) {
                        obj.details.last_name = names[2]
                    }
                    else if(!obj.details.last_name && !!names[1] && names.length < 3 ){
                        obj.details.last_name = names[1]
                    }
                }
                return (this.countryCode === 'POL' && ((obj.details && obj.details.hasOwnProperty('first_name')) || (obj.type && obj.type === 'other' && obj.details && obj.details.hasOwnProperty('legal_name')) ))
            },
            selected: function () {
                this.selectMode = false;
                this.select2Open = false;
                this.companySelect2Open = false;
            },
            // resizeModal: function () {
            //     this.windowWidth = window.innerWidth;
            //     this.isMobileView = window.innerWidth < 576;
            // },
            search: function () {
                if (this.searchValue !== '') {
                    this.doSearch();
                }
            },
            getFullName: function(data) {
                return `${data.first_name} ${data.last_name}`
            },
            prepValue: function (obj, is_shareholder) {
                let type = obj.type;
                let entity = obj['details'];
                //transparent data doesn't send type so it is empty
                let first_name, last_name, legal_name, percentage_of_shares = ''
                first_name = entity.hasOwnProperty('first_name') ? entity['first_name'] : ''
                last_name = entity.hasOwnProperty('last_name') ? entity['last_name'] : ''
                legal_name = entity.hasOwnProperty('legal_name') ? entity['legal_name'] : ''
                percentage_of_shares = entity.hasOwnProperty('percentage_of_shares') ? entity['percentage_of_shares'] : ''
                let entity_name = (type === 'person' || type === "" || entity.hasOwnProperty('first_name')) ? (first_name + ' ' +  last_name) :  legal_name;
                return  entity_name + (is_shareholder ? ` - ${ percentage_of_shares}% - ${ !!entity['share_class'] ? entity['share_class'] : '' }` : '');
            },
            toggleDirectors() {
                if(!!this.selectedShareholderIndex) {
                    this.selectedDirectorIndex = null;
                }
            },
            toggleShareholders() {
                if(!!this.selectedDirectorIndex) {
                    this.selectedShareholderIndex = null;
                }
            },
            toggleCompanySearchOption() {
                this.companyList = [];
                this.companyDetail = [];
                this.companyAddresses = [];
                this.registered_address = [];
                this.personnel_data = {};
            },
            selectCompany: function (company) {
                this.selectedCompany = company;
                this.getCompanyDetails(company);
            },
            searchPersonnelCompany: function (data) {
                this.searchBy = this.searchByOptions.company_name;
                this.dataCompanyName = data;
                this.searchValue = this.dataCompanyName;
                if (this.searchValue !== '') {
                    this.doSearch();
                }
            },
            searchByCompanyName: function () {
                this.searchBy = this.searchByOptions.company_name;
                this.searchValue = this.dataCompanyName;
                if (this.searchValue !== '') {
                    this.doSearch();
                }
            },
            searchByRegNumber: function (regNo = null) {
                //set searchBy and value when called externally
                this.dataRegNumber = !!regNo ? regNo : this.registrationNumber
                this.searchBy = this.searchByOptions.reg_no
                this.searchValue = this.dataRegNumber

                if (this.searchValue !== '') {
                    this.doSearch();
                }
            },
            searchByVatNumber: function (vatNo = null) {
                //set searchBy and value when called externally
                this.dataVatNumber = !!vatNo ? vatNo : this.vatNumber;
                this.searchBy = this.searchByOptions.vat_no;
                this.searchValue = this.dataVatNumber;

                if (this.searchValue !== '') {
                    this.doSearch();
                }
            },
            doSearch: function () {
              //set searchBy when called externally
              let search_key = '';
              let payload = {
                'country_code': this.countryCode
              };
              const is_personnel = this.personnel > 0;

              // this fails for reg_numbers with alphabets
              // if (!isNaN(this.searchValue)){
              //     search_key = payload['company_id'] = this.searchValue;
              //     this.searchBy = this.searchByOptions.reg_no
              // }else{
              //     search_key = payload['company_name'] = this.searchValue;
              //     this.searchBy = this.searchByOptions.company_name
              // }

              // this is to allow the user change the search from the modal. searchValue takes dominance
              // if (this.searchBy === this.searchByOptions.reg_no && this.previous_search !== this.searchValue && this.previous_search !== null) {
              //     search_key = payload['company_id'] = this.searchValue;
              // }
              // else if(this.previous_search !== this.searchValue && this.previous_search !== null)
              // {
              //     search_key = payload['company_name'] = this.searchValue;
              // }
              // else
              if (this.searchBy === this.searchByOptions.reg_no) {
                search_key = payload['company_id'] = this.searchValue;
                if (!!this.businessType && this.search_bisnode_data) {
                  payload['business_type'] = this.businessType;
                  search_key = this.businessType + '_' + search_key;
                }
              }
              else if (this.searchBy === this.searchByOptions.vat_no) {
                search_key = payload['vat_number'] = this.searchValue;
                if (!!this.businessType && this.search_transparent_data) {
                  payload['business_type'] = this.businessType;
                  search_key = this.businessType + '_' + search_key;
                }
              }
              else {
                search_key = payload['company_name'] = this.searchValue;
              }

              for (const prop in this.reference) {
                payload[prop] = this.reference[prop];
              }
              const url = '/externalservices/searchbusiness';

              this.loading = true;
              this.companyList = [];
              this.companyDetail = [];
              this.companyAddresses = [];
              this.registered_address = [];

              const cache_key = `${search_key}_${payload.country_code}`;
              if (this.cache.company_search.hasOwnProperty(cache_key) && this.previous_search === cache_key) {
                let data = this.cache.company_search[cache_key];
                this.setSearchData(cache_key, data, is_personnel);
              }
              else {
                this.getAxiosInstance().post(url, payload)
                    .then(response => {
                      const data = response.data;
                      this.setSearchData(cache_key, data, is_personnel);

                    })
                    .catch(error => {
                      this.loading = false;
                      this.error_message = this.lang('details_not_found');
                    })
              }
            },
            setSearchData: function (cache_key, data, is_personnel) {
              this.previous_search = cache_key;

              if (Array.isArray(data)) {
                this.companyList = this.companyAdaptor(data);
                this.cache.company_search[cache_key] = this.companyList;
                //let the user select before making retrieve call.
                if (this.searchBy === this.searchByOptions.reg_no) {
                  this.selectCompany(this.companyList[0].id);
                } else {
                  this.companySelect2Open = true;
                }
              }
              else {
                let is_transparentdata_vat_search = (this.searchBy === this.searchByOptions.vat_no && this.search_transparent_data);
                let is_bisnode_register_number_search = (this.searchBy === this.searchByOptions.reg_no && this.search_bisnode_data);

                if (is_transparentdata_vat_search || is_bisnode_register_number_search) {
                  this.cache.company_search[cache_key] = data;
                  if (is_personnel) {
                    this.personnel_data = data;
                  } else {
                    this.prepareCompanyData(this.cache.company_search[cache_key]);
                  }
                }
              }

              // console.error(data)
              this.loading = false;
            },
            setPersonnelMode: function (personnel_mode) {
                //set searchBy when called externally
                this.personnel = personnel_mode;
            },
            isLongDetail: function(detail) {
                let long_details = ['legal_name', 'trading_address', 'description'];
                return long_details.indexOf(detail) > -1;
            },
            isDescriptive: function(detail) {
                let descriptive_keys = ['accounts_turnover', 'monthly_turnover', 'business_type', 'description', 'reg_web', 'trading_address'];
                return descriptive_keys.indexOf(detail) > -1;
            },
            getCompanyDetails: function (id) {
                const is_personnel = this.personnel > 0;
                // const url = is_personnel ?  '/externalservices/getshareholders' : '/externalservices/getcompany';
                const url = '/externalservices/retrievebusiness';
                const payload = is_personnel ? {company_id: id, shareholder_mode: this.personnel} : {company_id: id};
                payload['country_code'] = this.country;
                for (const prop in this.reference) {
                    payload[prop] = this.reference[prop];
                }
                const cacheKey = !!this.cacheKeys[this.personnel] ? this.cacheKeys[this.personnel] : 0;

                if(this.cache[cacheKey].hasOwnProperty(id)) {
                    if(is_personnel) {
                        this.personnel_data = this.cache[cacheKey][id];
                    } else {
                        this.prepareCompanyData(this.cache[cacheKey][id]); // cache data
                    }
                } else {
                    this.loading = true;
                    this.getAxiosInstance().post(url, payload)
                        .then(response => {
                            const data = response.data;
                            if (data) {
                                if(is_personnel) {
                                    this.personnel_data = data;
                                } else {
                                    this.prepareCompanyData(data);
                                }
                                this.cache[cacheKey][id] = data; // cache data
                            }
                            this.loading = false;
                        })
                        .catch(error => {
                            this.loading = false;
                        })
                }
            },
            prepareCompanyData(data) {
                let vm = this;
                this.companyAddresses = data.postcoder_address;//.map(this.addressAdaptor);
                this.companyDetail = this.companyDetailAdaptor(data.company);

                let registered_address = [];
                if(this.objectIsNotEmpty(data.company) && data.company.registered_address) {
                    registered_address = vm.addressAdaptor(data.company.registered_address);
                }
                this.registered_address = !!registered_address ? registered_address : '';
            },
            getNumberFromString: function (str) {
                let num = !!str ? str.replace(/[^0-9]/g, '') : null;
                return !!num ? parseInt(num, 10) : '';
            },
            removeNumberFromString: function (str) {
                return !!str ? str.replace(/[0-9]/g, '') : '';
            },
            filterCompany: function (key) {
                const options = {
                    shouldSort: true,
                    keys: [
                        "name"
                    ]
                };
                const fuse = new Fuse(this.companyList, options);
                if (this.companyFilterKey) {
                    return fuse.search(key);
                } else {
                    return this.companyList;
                }
            },
            getSelectedPersonnel: function () {
                let selectedPersonnel;
                if(!!this.selectedDirectorIndex) {
                    selectedPersonnel = this.directorOptions.find((obj) => { return obj.value === this.selectedDirectorIndex})
                }
                if(!!this.selectedShareholderIndex) {
                    selectedPersonnel = this.shareholderOptions.find((obj) => { return obj.value === this.selectedShareholderIndex})
                }
               return (!!selectedPersonnel && selectedPersonnel.hasOwnProperty('details')) ? selectedPersonnel['details'] : {};
            },
            useSelectedDetails: function() {
                // let selectedPersonnel = this.getSelectedPersonnel();
                const data = {
                    companyDetails: this.selectedCompanyDetails,
                    shareholder: this.getSelectedPersonnel(),
                    address: this.selectedAddressIndex !== null && this.objectIsNotEmpty(this.companyAddresses) ? this.companyAddresses[this.selectedAddressIndex] : null,
                    registered_address: this.registered_address ? this.registered_address : null,
                };
                //EventBus.$emit('data', data);
                this.$emit('data', data);
            },
            isCharMatchKey: function (companyName, index) {
                //if (!this.companyFilterKey) return false;
                const indexes = [];
                //find first occurrence of search key chars on company name string
                this.companyFilterKey.split('').forEach(c => {
                    const len = indexes.length;
                    const last = len > 0 ? indexes[len - 1] : 0;
                    const charIndex = companyName.toLowerCase().indexOf(c.toLowerCase(), last);
                    if (charIndex > -1) {
                        indexes.push(charIndex);
                    }
                })
                return indexes.includes(index);
            },
            show: function () {
                // $('#company-search-modal').modal();
                var myModalEl = document.querySelector('#company-search-modal')
                var modal = bootstrap.Modal.getOrCreateInstance(myModalEl) // Returns a Bootstrap modal instance
                modal.show()
            }

        },
        watch: {
            companyName(value) {
               this.dataCompanyName = value;
            },
            registrationNumber(value) {
               this.dataRegNumber = value;
            },
            searchBy: function (value) {

                if (this.searchBy === this.searchByOptions.reg_no){
                    this.searchValue = this.registrationNumber;
                }
                else if (this.searchBy === this.searchByOptions.vat_no) {
                    this.searchValue = this.vatNumber;
                }
                else {
                    this.searchValue = this.companyName
                }
            }
        }
    }
</script>
<style scoped>
    .search-addon{
        border-radius: 0 !important;
    }
    .company-name-char {
        display: inline !important;
        font-size: 1em !important;
    }
    .business-detail {
        min-height: 40px;
    }
    .match {
        font-weight: bold;
    }
    .dd_shareholder.col-9{
        margin-left: -10px;
    }
    .dd_borders {
        border-bottom: 1px solid white;
    }
    .dd_borders:last-child{
        border-bottom: none;
    }
</style>
